import type { AuditUpdateRequest } from '../services/auditService';

// Convert React form state into the shape expected by the audit API
export const convertFormToApiData = (formData: any): AuditUpdateRequest => {
  let dateInMmDdYy = formData.shift_date;
  if (formData.shift_date && formData.shift_date.includes('-')) {
    const [year, month, day] = formData.shift_date.split('-');
    const yy = year.slice(-2);
    dateInMmDdYy = `${month}/${day}/${yy}`;
  }

  return {
    action: formData.action,
    notes: formData.notes,
    confidence_score: Number(formData.confidence_score),
    parsed_data: {
      final_json: {
        date: dateInMmDdYy,
        time: `${formData.shift_start_time} TO ${formData.shift_end_time}`,
        ticket_details: (formData.ticket_details || []).map((data: any) => ({
          game: data.game,
          name: data.name,
          pack: data.pack,
          range: data.range,
        })),
        retailer: formData.retailer_id,
      },
    },
  } as unknown as AuditUpdateRequest;
};

// Convert API audit payload back into a form-friendly structure
export const convertApiToFormData = (apiData: any, currentFormData: any) => {
  const finalJson = apiData.parsed_data?.final_json || {};
  let shift_date = '';
  let shift_start_time = '';
  let shift_end_time = '';

  if (finalJson.date && finalJson.time) {
    const [yy, mm, dd] = finalJson.date.split('/');
    const yyyy = Number(yy) < 50 ? '20' + yy : '19' + yy;
    shift_date = `${yyyy}-${mm}-${dd}`;
    const [startTime, endTime] = finalJson.time.split(' TO ');
    shift_start_time = startTime || '';
    shift_end_time = endTime || '';
  }

  const basicFormData = {
    action: apiData.action || 'finalize',
    notes: apiData.notes || '',
    confidence_score: apiData.confidence_score || 0,
    shift_date,
    shift_start_time,
    shift_end_time,
    ticket_details: finalJson.ticket_details || [],
    retailer_id: finalJson.retailer || '',
  };

  const mergedFormData = {
    ...currentFormData,
    ...basicFormData,
    ticket_details: basicFormData.ticket_details.map((apiTicket: any, index: number) => {
      const currentTicket = currentFormData?.ticket_details?.[index] || {};
      return {
        ...currentTicket,
        ...apiTicket,
      };
    }),
  };

  return mergedFormData;
};


